import React from "react";
import PropTypes from "prop-types";
import { keyCodes } from "lib";
import { MANUAL_SAVE_EVENT } from "lib/constants";
class keyboardShortcuts extends React.Component {
  constructor(props) {
    super(props);

    this.handleKeydown = this.handleKeydown.bind(this);
  }

  handleKeydown(event) {
    if (!document.body.contains(event.target)) {
      return;
    }

    // Ctrl/Cmd+S should always trigger save regardless of focus location
    if ((event.ctrlKey || event.metaKey) && event.keyCode === keyCodes.sKey) {
      event.preventDefault();
      if (this.props.onSaveImmediate && !this.props.areHeadersButtonsLocked) {
        window.dispatchEvent(new CustomEvent(MANUAL_SAVE_EVENT));
        this.props.onSaveImmediate();
      }
      return;
    }

    const editorSidebarDom = document.querySelector("#editor-sidebar");
    const editorActionbarDom = document.querySelector("#editor-actionbar");
    const editorHeaderDom = document.querySelector("#editor-header");
    const editorDom = document.querySelector("#editor-core");
    const mobileBottomSheetDom = document.querySelector(
      "[data-testid='mobile-bottom-sheet']"
    );

    // prevent keyboard shortcuts from interrupting default shortcuts for sidebar, actionbar and header
    if (
      // the current target is in the editor sidebar, actionbar, or header
      (editorSidebarDom && editorSidebarDom.contains(event.target)) ||
      (editorActionbarDom && editorActionbarDom.contains(event.target)) ||
      (editorHeaderDom && editorHeaderDom.contains(event.target)) ||
      // or the current target is in the mobile bottom sheet (sidebar/actionbar on mobile)
      (mobileBottomSheetDom && mobileBottomSheetDom.contains(event.target)) ||
      // or the current target is not inside the editor context
      (editorDom &&
        !editorDom.contains(event.target) &&
        !event.target.isEqualNode(document.body))
    ) {
      // we should pass on control
      return;
    }

    this.stopDefaultBackspaceBehaviour(event);

    // SHORTCUTS NOT BLOCKED BY FUNCTIONALITY LOCK START
    switch (event.keyCode) {
      // ZOOM IN FUNCTION
      case keyCodes.plusKeyStandard:
      case keyCodes.plusKeyFirefox:
      case keyCodes.plusKeyNumPad:
        if (event.ctrlKey || event.metaKey) {
          event.preventDefault();
          if (this.props.isInCroppingMode) {
            this.props.cancelCurrentCropMode();
            return;
          }
          this.props.bumpZoomUp();
        }
        break;
      //ZOOM OUT FUNCTION
      case keyCodes.minusKeyStandard:
      case keyCodes.minusKeyFirefox:
      case keyCodes.minusKeyNumPad:
        if (event.ctrlKey || event.metaKey) {
          event.preventDefault();
          if (this.props.isInCroppingMode) {
            this.props.cancelCurrentCropMode();
            return;
          }
          this.props.bumpZoomDown();
        }
        break;

      // FIT TO PAGE - Ctrl/Cmd + 0
      case keyCodes.zeroKeyNumPad:
      case keyCodes.zeroKey:
        if (event.ctrlKey || event.metaKey) {
          event.preventDefault();
          if (this.props.isInCroppingMode) {
            this.props.cancelCurrentCropMode();
            return;
          }
          this.props.fitToPage();
        }
        break;

      // ZOOM TO 100% - Ctrl/Cmd + 1
      case keyCodes.oneKeyNumPad:
      case keyCodes.oneKey:
        if (event.ctrlKey || event.metaKey) {
          event.preventDefault();
          if (this.props.isInCroppingMode) {
            this.props.cancelCurrentCropMode();
            return;
          }
          this.props.setZoom(1);
        }
        break;

      default:
        break;
    }
    // SHORTCUTS NOT BLOCKED BY FUNCTIONALITY LOCK END

    // we always want this to check before any of the functionality that are affected by locking
    // if editor functionalities are locked then so should keyboard shortcuts
    if (this.props.areFunctionalitiesLocked) return;

    // SHORTCUTS BLOCKED BY FUNCTIONALITY LOCK START
    switch (event.keyCode) {
      //UNDO FUNCTION
      /* eslint-disable-next-line */
      case keyCodes.zKey: {
        if (!event.ctrlKey && !event.metaKey) return;

        event.preventDefault();
        if (event.shiftKey) {
          if (this.props.isInCroppingMode) {
            this.props.cancelCurrentCropMode();
            return;
          }
          this.props.onRedo();
        } else {
          if (this.props.isInCroppingMode) {
            this.props.cancelCurrentCropMode();
            return;
          }
          this.props.onUndo();
        }
        break;
      }

      case keyCodes.yKey: {
        if (!event.ctrlKey && !event.metaKey) return;
        event.preventDefault();
        if (this.props.isInCroppingMode) {
          this.props.cancelCurrentCropMode();
          return;
        }
        this.props.onRedo();
        break;
      }

      //DELETE ELEMENT FUNCTION
      case keyCodes.backspaceKey:
      case keyCodes.deleteKey: {
        if (this.props.isInCroppingMode) {
          this.props.cancelCurrentCropMode();
          return;
        }
        this.props.onDelete();
        break;
      }

      //BUMP ELEMENT FUNCTION
      case keyCodes.upKey:
      case keyCodes.downKey:
      case keyCodes.leftKey:
      case keyCodes.rightKey: {
        if (this.props.isInCroppingMode) {
          this.props.cancelCurrentCropMode();
          return;
        }
        this.props.onBump(event);
        break;
      }

      // SELECT ALL ELEMENTS ON PAGE FUNCTION
      case keyCodes.aKey:
        if (event.ctrlKey || event.metaKey) {
          event.preventDefault();
          if (this.props.isInCroppingMode) {
            this.props.cancelCurrentCropMode();
            return;
          }
          /* ctrl-a or cmd-a should select all elements on a page */
          this.props.onSelectAll();
        }
        break;

      // COPY SELECTION / COPY STYLE TO CLIPBOARD
      case keyCodes.cKey:
        if (event.ctrlKey || event.metaKey) {
          if (this.props.isInCroppingMode) {
            this.props.cancelCurrentCropMode();
            return;
          }
          event.preventDefault();
          if (event.altKey) {
            /* ctrl-opt-c or cmd-opt-c should copy style from selected element */
            if (this.props.copyStyleFromSelection) {
              this.props.copyStyleFromSelection();
            }
          } else {
            /* ctrl-c or cmd-c should copy all selected elements to clipBoard */
            this.props.copyElementsToClipBoard();
          }
        }
        break;

      // GROUP / UNGROUP SELECTION
      case keyCodes.gKey:
        if (event.ctrlKey || event.metaKey) {
          if (this.props.isInCroppingMode) {
            this.props.cancelCurrentCropMode();
            return;
          }
          event.preventDefault();
          if (event.shiftKey) {
            /* ctrl-shift-g or cmd-shift-g should ungroup the selected group */
            if (this.props.onUngroup) {
              this.props.onUngroup();
            }
          } else {
            /* ctrl-g or cmd-g should group selected elements */
            if (this.props.onGroup) {
              this.props.onGroup();
            }
          }
        }
        break;

      // PASTE SELECTION / PASTE STYLE FROM CLIPBOARD
      case keyCodes.vKey:
        if (event.ctrlKey || event.metaKey) {
          if (this.props.isInCroppingMode) {
            this.props.cancelCurrentCropMode();
            return;
          }
          event.preventDefault();
          if (event.altKey) {
            /* ctrl-opt-v or cmd-opt-v should paste style onto selected elements */
            if (this.props.pasteStyleToSelection) {
              this.props.pasteStyleToSelection();
            }
          } else {
            /* ctrl-v or cmd-v should paste all elements from clipBoard */
            this.props.pasteElementsFromClipBoard();
          }
        }
        break;

      default:
        break;
    }
    // SHORTCUTS BLOCKED BY FUNCTIONALITY LOCK END
  }

  handleKeyPress(event) {
    this.stopDefaultBackspaceBehaviour(event);
  }

  stopDefaultBackspaceBehaviour(event) {
    event = event || window.event;
    if (event.keyCode === keyCodes.backspaceKey) {
      var elements = "HTML, BODY, TABLE, TBODY, TR, TD, DIV";
      var source = event.srcElement || event.target;
      var regex = new RegExp(source.tagName.toUpperCase());
      if (source.contentEditable !== "true") {
        //it's not REALLY true, checking the boolean value (!== true) always passes, so we can use != 'true' rather than !== true/
        if (regex.test(elements)) {
          event.preventDefault
            ? event.preventDefault()
            : (event.returnValue = false);
        }
      }
    }
  }

  componentDidMount() {
    window.addEventListener("keydown", this.handleKeydown);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeydown);
  }

  render() {
    return null;
  }
}

keyboardShortcuts.propTypes = {
  onUndo: PropTypes.func,
  onRedo: PropTypes.func
};

export default keyboardShortcuts;
